import NoData from "assets/svgs/no_data/NoData";
import PaginationDiv from "modules/pagination/PaginationDiv";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CheckOutlined } from "@ant-design/icons";

import OutwardTransitModal from "./OutwardTransitModal";
import { fourPlaceHolder } from "modules/utilities/utility";

function OutwardTransitTable({ isLoading, warehouses, transitData }) {
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [page, newPage] = useState(1);
  const [sortData, setSortedData] = useState([]);
  const [show, setShow] = useState(false);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    setSortedData(transitData);
  }, [transitData]);

  function handleShow(item) {
    setOrder(item);
    setShow(true);
  }

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  const getWarehouse = (id) => {
    let result = warehouses.find((element) => element.value === id);
    return result?.label;
  };

  const header = [
    "Date",
    "From Warehouse",
    "To Warehouse",
    "Sku",
    "Available to Allocate",
    "Allocation",
  ];
  return (
    <div>
      <div className="mt-1 shadow rounded mt-5">
        <div className="d-flex table-head rounded-top">
          {header?.map((item) => {
            return (
              <span className="p-3 fw-bold text-black flex-1 border-end">
                {item}
              </span>
            );
          })}
        </div>
        {isLoading ? (
          fourPlaceHolder()
        ) : filterData && filterData?.length ? (
          filterData?.map((item, index) => {
            return (
              <div
                className={`d-flex table-row border- border-top-0 ${
                  index === filterData?.length - 1 && `rounded-bottom`
                }`}
              >
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {moment(item?.inwardImportDate).format("DD MMM YYYY, h:mm a")}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {getWarehouse(item?.fromWarehouseId)}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {getWarehouse(item?.toWarehouseId)}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {item?.skuName}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  {Number(item?.quantity) -Number(item.inwardedQuantity)}
                </span>
                <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                  <div>
                    <CheckOutlined
                      className="bg-primary p-2 text-white fw-bold rounded-circle"
                      onClick={() => handleShow(item)}
                    />
                  </div>
                </span>
              </div>
            );
          })
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            {" "}
            No Data Available <NoData />
          </div>
        )}
      </div>
      <PaginationDiv
        paginationData={{ pageCount: pageCount || 1, page: page }}
        newPage={newPage}
        activePage={page}
      />
      <OutwardTransitModal show={show} setShow={setShow} order={order} />
    </div>
  );
}

export default OutwardTransitTable;
